export default __webpack_public_path__ + "static/media/whats.4f00aaa3.png";